import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { liveClassesAPI } from '../../services/api';

const LiveClasses = () => {
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            try {
                const res = await liveClassesAPI.getAll();
                setClasses(res.data || []);
            } catch (error) {
                console.error('Failed to fetch live classes', error);
                setClasses([]);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const handleJoin = async (item) => {
        try {
            // Check if logged in here, or just let route handler/component do it
            navigate(`/live-classes/${item.id}`);
        } catch (error) {
            alert('Unable to join live class right now.');
        }
    };

    const upcomingClasses = classes.filter(c => c.status !== 'COMPLETED');
    const recordedClasses = classes.filter(c => c.status === 'COMPLETED');

    return (
        <div style={styles.page}>
            <div className="container" style={styles.container}>
                <h1 style={styles.title}>Live Classes & Recordings</h1>
                <p style={styles.subtitle}>Join live interactive sessions or watch past class recordings on-demand.</p>

                {loading ? (
                    <div style={styles.emptyBox}>Loading classes...</div>
                ) : classes.length === 0 ? (
                    <div style={styles.emptyBox}>No live classes or recordings available yet.</div>
                ) : (
                    <>
                        {upcomingClasses.length > 0 && (
                            <div style={styles.section}>
                                <h2 style={styles.sectionTitle}>Upcoming & Live Sessions</h2>
                                <div style={styles.grid}>
                                    {upcomingClasses.map((item) => (
                                        <div key={item.id} style={styles.card}>
                                            <h3 style={styles.cardTitle}>
                                                {item.status === 'LIVE_NOW' && <span style={styles.liveBadge}>🔴 LIVE </span>}
                                                {item.title}
                                            </h3>
                                            <p style={styles.cardDesc}>{item.description || 'Live session with instructor guidance.'}</p>
                                            <div style={styles.meta}>Instructor: {item.instructor_name || 'ARIVUNEST Instructor'}</div>
                                            <div style={styles.meta}>Starts: {new Date(item.start_time).toLocaleString()}</div>
                                            <button type="button" style={item.status === 'LIVE_NOW' ? styles.liveJoinBtn : styles.joinBtn} onClick={() => handleJoin(item)}>
                                                {item.status === 'LIVE_NOW' ? 'Join Now (Live)' : 'Join Live Class'}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {recordedClasses.length > 0 && (
                            <div style={styles.section}>
                                <h2 style={styles.sectionTitle}>Past Recordings (VOD)</h2>
                                <div style={styles.grid}>
                                    {recordedClasses.map((item) => (
                                        <div key={item.id} style={styles.card}>
                                            <h3 style={styles.cardTitle}>{item.title}</h3>
                                            <p style={styles.cardDesc}>{item.description || 'Recorded session.'}</p>
                                            <div style={styles.meta}>Instructor: {item.instructor_name || 'ARIVUNEST Instructor'}</div>
                                            <div style={styles.meta}>Finished: {new Date(item.end_time || item.start_time).toLocaleString()}</div>
                                            <button type="button" style={styles.watchBtn} onClick={() => handleJoin(item)}>
                                                🎬 Watch Recording
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

const styles = {
    page: { minHeight: '100vh', background: '#f8fafc', paddingTop: '90px' },
    container: { padding: '20px 16px 40px' },
    title: { fontSize: '42px', margin: 0, color: '#0f172a' },
    subtitle: { color: '#64748b', marginTop: '10px', marginBottom: '20px' },
    emptyBox: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '14px', padding: '24px', color: '#475569' },
    section: { marginBottom: '40px' },
    sectionTitle: { fontSize: '24px', color: '#0f172a', marginBottom: '16px', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' },
    card: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '14px', padding: '16px' },
    cardTitle: { margin: 0, fontSize: '20px', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px' },
    liveBadge: { color: '#ef4444', fontSize: '14px', fontWeight: 'bold' },
    cardDesc: { color: '#475569', fontSize: '14px', minHeight: '44px', marginTop: '6px' },
    meta: { color: '#64748b', fontSize: '13px', marginBottom: '6px' },
    joinBtn: { marginTop: '10px', width: '100%', border: 'none', borderRadius: '8px', padding: '10px', background: '#2563eb', color: '#fff', fontWeight: '700', cursor: 'pointer' },
    liveJoinBtn: { marginTop: '10px', width: '100%', border: 'none', borderRadius: '8px', padding: '10px', background: '#dc2626', color: '#fff', fontWeight: '700', cursor: 'pointer', animation: 'pulse 2s infinite' },
    watchBtn: { marginTop: '10px', width: '100%', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '10px', background: '#f8fafc', color: '#0f172a', fontWeight: '700', cursor: 'pointer' },
};

export default LiveClasses;
